import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import idx from 'idx';
import partial from 'lodash/partial';
import { createNDA, toggleSignModal, fetchContract, clearContract } from 'project/ducks/ndas';
import { getProject } from 'project/ducks/project';
import { getProjectIdFromUrl } from 'project/utils';
import SignNDA from 'project/components/sign_nda';

const mapStateToProps = (state) => {
  const { ndaContract, showingSignModal } = state.project.ndas;

  return {
    showing: showingSignModal && !!ndaContract,
    contract: ndaContract,
    signingAs: "creative",
    project: getProject(state),
    user: state.user.profile_data
  }
}

const mapDispatchToProps = dispatch => ({ dispatch });

const mergeProps = (stateProps, { dispatch }, ownProps) => {
  const projectId = getProjectIdFromUrl(ownProps.params);

  const dispatchProps = bindActionCreators({
    onClose: toggleSignModal,
    fetchContract: partial(fetchContract, projectId),
    onDone: partial(createNDA, projectId, idx(stateProps, _ => _.contract.id)),
    clearContract,
  }, dispatch);

  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps
  };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(SignNDA));



// WEBPACK FOOTER //
// ./project/containers/sign_nda.js